<template lang="html">
<div class="settlement" v-loading="fullLoading">
  <row>
    <div class="sl-col-4">
      <div class="sl-condition">
        <row>
          <div class="col-md-4">
            <div class="form-group">
              <el-date-picker v-model="datePicker" type="datetimerange" :placeholder="$t('Date.placeholder')"></el-date-picker>
            </div>
          </div>
          <div class="col-md-4 sm-margin">
            <div class="form-group">
              <sl-btn class="sl-btn-lightblue" :text="$t('Functional.confirm')" @click.native="searchByCondition"></sl-btn>
              <sl-btn class="sl-btn-lightred" :text="$t('Functional.clear')" @click.native="clearSelectors"></sl-btn>
            </div>
          </div>
        </row>
      </div>
    </div>
  </row>
  <row>
    <div class="sl-col-4">
      <div class="sl-body" v-loading="loading">
        <row style="margin-bottom: 10px;position: relative;left: 19px;">
          <div class="col-md-12">
            <div class="form-group" style="float:right">
              <sl-btn :text="$t('Functional.download')" icon="sl-download" @click.native="download"></sl-btn>
            </div>
          </div>
        </row>
        <row class="sl-table-reload" v-show="reloadBtn">
          {{$t('Notify.errorMsg')}}
          <sl-btn class="sl-btn-lightblue" :text="$t('Functional.reload')" @click.native="reloadTable"></sl-btn>
        </row>
        <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
          <el-table-column min-width="200" :fixed="$store.state.userAgent.isPhone ? !true : true" sortable='custom'  :show-overflow-tooltip="true" prop="transferDate" :label="$t('Views.Settlement.table.tDate')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="amount" :label="$t('Views.Settlement.table.sAmount')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="uploadTime" :label="$t('Views.Settlement.table.cTime')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="status" :label="$t('Views.Settlement.table.sStatus')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="settleTime" :label="$t('Views.Settlement.table.sTime')"> </el-table-column>
          <el-table-column :min-width="$store.state.userAgent.isPhone ? 100 : 200" fixed="right" :show-overflow-tooltip="true" :label="$t('Table.actions')">
            <template scope="scope">
              <el-button class="sl-detail" size="small" @click="downStatement(scope.row.id)">{{$t('Functional.download')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!reloadBtn" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.per" layout=" prev, pager, next, sizes,jumper,total" :total="table.total"> </el-pagination>
      </div>
    </div>
  </row>
</div>
</template>

<script>
import api from '../../api'
import moment from '../../util/date'
import download from '../../util/download'
import * as types from '../../store/types'
export default {
  name: 'Transactions',
  data() {
    return {
      fullLoading: false,
      loading: false,
      tableData: [],
      table: this.$store.state.settlements.table,
      condition: this.$store.state.settlements.condition,
      datePicker: this.$store.state.settlements.datePicker,
      reloadBtn: false
    }
  },
  methods: {
    handleSizeChange(per) {
      this.table.per = per
      updateTable(this, initParams(this))
    },
    handleCurrentChange(page) {
      this.table.page = page
      updateTable(this, initParams(this))
    },
    handleSortChange({
      column,
      prop,
      order
    }) {
      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      }
      updateTable(this, initParams(this))
    },
    clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Settlements')
      this.condition = {
        begin: '',
        end: ''
      }
      this.datePicker = []
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Settlements')
      updateTable(this, initParams(this))
    },
    download() {
      this.$ga.event('Button', 'Download', 'Settlements')
      const params = Object.assign({}, initParams(this))
      let st = ''
      for (let i in params) {
        if (params.hasOwnProperty(i)) {
          st = st + '&' + i + '=' + params[i]
        }
      }
      const url = '/client/settlement?download=csv' + st
      window.open(url)
    },
    downStatement(id) {
      this.$ga.event('Button', 'Download Statement', 'Settlements')
      const vm = this
      this.fullLoading = true
      api.DownloadStatement(id).then(function (response) {
        const data = new Blob([response.data], {
          type: response.headers['content-type']
        })
        download(data, response.headers['content-disposition'].replace(/"/g, '').split('filename=')[1])
        vm.fullLoading = false
      })
    },
    reloadTable() {
      this.$ga.event('Button', 'Reload', 'Settlements')
      updateTable(this, initParams(this))
    }
  },
  created() {
    updateTable(this, initParams(this))
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(types.InitSettleTable)
    next()
  }
}
// 更新表单 。 默认每页10条，页码为1
function updateTable(vm, params) {
  vm.loading = true
  api.FetchSettleTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    }
    vm.tableData = result.list
    vm.reloadBtn = vm.loading = false
  }).catch(error => {
    console.log(error)
    vm.tableData = []
    vm.loading = false
    vm.reloadBtn = true
  })
}
// 初始化table请求接口的参数
function initParams(vm) {
  vm.$store.commit(types.SetSettleTable, {
    table: Object.assign({}, vm.table),
    condition: Object.assign({}, vm.condition),
    datePicker: vm.datePicker.map(item => item)
  })
  const ts = Object.assign({}, vm.$store.state.settlements)
  let tb = JSON.parse(JSON.stringify(ts.table))
  let cd = JSON.parse(JSON.stringify(ts.condition))
  if (ts.datePicker.length === 2) {
    cd.begin = ts.datePicker[0] === null ? '' : moment(ts.datePicker[0]).format('LT')
    cd.end = ts.datePicker[1] === null ? '' : moment(ts.datePicker[1]).format('LT')
  } else {
    delete cd.begin
    delete cd.end
  }
  return Object.assign({}, tb, cd)
}
</script>
<style>
.settlement div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.settlement div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// settlements.vue?5deedbce